<div class="title">
    <span>{{ 'translation:Edit item' | i18next }}</span>
</div>
<div class="dialog-content">
    <div class="add-container">
        <app-widget-textbox [model]="newNodeName" (modelChange)="newNodeName=$event"
            title="{{ 'translation:Name' | i18next }}" placeholder="{{ 'translation:Name' | i18next }}"
            textboxWidth="420px"></app-widget-textbox>
        <br>
        <br>
        <app-widget-textbox *ngIf="isTopic && isStorageTimeFieldVisible()" class="input-storage" [model]="storageTime"
            (modelChange)="storageTime=$event" title="{{ 'translation:Days to store recording' | i18next }}"
            placeholder="As configured in Archive" textboxWidth="200px" [numericOnly]="true"
            [tooltip]="tooltip" [disabled]="isStorageTimeFieldDisabled()" (validityChange)="onStorageTimeValidityChange($event)" [errorMessage]="errorMessage"></app-widget-textbox>
        <mat-checkbox *ngIf="isTopic" class="checkbox" id="sensitive" [checked]="isSensitive"
            [matTooltip]="'translation:Sensitive Tooltip' | i18next" matTooltipClass="tooltip"
            (change)="sensitiveState($event)">{{ 'dashboard:Sensitive' | i18next
            }}</mat-checkbox>
    </div>
</div>
<mat-dialog-actions>
    <button mat-flat-button [ngClass]="['secondary-button']" (click)="closeDialog()">{{ 'translation:Cancel' | i18next
        }}</button>
    <button mat-flat-button [ngClass]="['primary-button', 'add-button-dialog']" (click)="editNode()"
        [disabled]="isApplyDisabled()">{{
        'translation:Apply' |
        i18next }}</button>
</mat-dialog-actions>